<app-data-table [elements]="tasks" [paginationTotal]="paginationTotal" [tableConfig]="tableConfig"
  [resetPageEvent]="eventResetPage.asObservable()" (reload)="refresh($event)">
</app-data-table>
